export default __webpack_public_path__ + "static/media/hero1.0743ceef.png";